/* KDK_MORE_LOOKS_V4 - 200 unique pairings, shopper-controlled, no early repetition */
(function(){
  'use strict';
  var AUDIENCES={women:'Kadın',men:'Erkek',kids:'Çocuk',family:'Aile Uyumu',jewelry:'Takı & Aksesuar'};
  var LANG='tr-TR';
  var productCache=new Map();
  var rootPath=((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/');
  if(rootPath.slice(-1)!=='/')rootPath+='/';
  var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'TRY';

  function getHandle(href){
    if(!href)return '';
    try{var url=new URL(href,window.location.href);
      if(url.origin!==window.location.origin)return '';
      var match=url.pathname.match(/\/products\/([^/?]+)/);
      return match?decodeURIComponent(match[1]):'';
    }catch(e){return '';}
  }
  function signature(handles){return handles.filter(Boolean).slice().sort().join('|');}
  function formatPrice(cents){
    var amount=Number(cents)/100;
    if(!(amount>0))return '';
    try{return new Intl.NumberFormat(LANG,{style:'currency',currency:currency,maximumFractionDigits:2}).format(amount);}
    catch(e){return amount.toFixed(2)+' '+currency;}
  }
  function verifyImage(source){
    if(!source)return '';
    var image=typeof source==='string'?source:(source.src||source.url||'');
    if(!image)return '';
    if(image.slice(0,2)==='//')image='https:'+image;
    try{var url=new URL(image,window.location.href);
      if(url.protocol!=='https:'&&url.protocol!=='http:')return '';
      return url.href;
    }catch(e){return '';}
  }
  function fetchProduct(handle){
    if(productCache.has(handle))return productCache.get(handle);
    var path=rootPath+'products/'+encodeURIComponent(handle)+'.js';
    var task=fetch(path,{method:'GET',credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(response){if(!response.ok)throw new Error('Product not available');return response.json();})
      .then(function(item){
        var variants=Array.isArray(item.variants)?item.variants:[];
        var available=variants.filter(function(v){return v.available&&Number(v.price)>0;});
        if(item.available===false||!available.length)throw new Error('No available variant');
        var image=verifyImage(item.featured_image||(item.images||[])[0]);
        var title=typeof item.title==='string'?item.title.trim():'';
        if(!image||!title)throw new Error('Missing customer-facing image/title');
        var lowest=available.reduce(function(v,x){return Math.min(v,Number(x.price));},Infinity);
        var price=formatPrice(lowest);
        if(!price)throw new Error('No valid current price');
        return {handle:handle,title:title,image:image,price:price,brand:item.vendor||'',url:rootPath+'products/'+encodeURIComponent(handle)};
      })
      .catch(function(err){productCache.delete(handle);throw err;});
    productCache.set(handle,task);
    return task;
  }
  function buildLook(look,products){
    var article=document.createElement('article');
    article.className='kdk-dynamic__slide kdk-dynamic__slide--curated';
    article.setAttribute('data-kdk-rendered-look','');
    var intro=document.createElement('div');intro.className='kdk-dynamic__slide-intro';
    var tag=document.createElement('span');tag.className='kdk-dynamic__theme-tag';
    var styleLabels={gunluk:'GÜNLÜK STİL',kislik:'KIŞ STİLİ',klasik:'KLASİK STİL',spor:'SPOR STİL',yazlik:'YAZ STİLİ',aile:'AİLE UYUMU',aksesuar:'ZARİF DETAYLAR'};
    tag.textContent=styleLabels[look.style]||'SEZONUN SEÇKİSİ';
    var title=document.createElement('h4');title.textContent=look.title;
    var sub=document.createElement('p');sub.textContent=look.subtitle;
    intro.appendChild(tag);intro.appendChild(title);intro.appendChild(sub);
    article.appendChild(intro);
    var grid=document.createElement('div');grid.className='kdk-dynamic__products kdk-dynamic__products--'+products.length;
    products.forEach(function(item){
      var card=document.createElement('a');card.className='kdk-dynamic__product';
      card.href=item.url;card.setAttribute('aria-label',item.title+' ürününü incele');
      var photo=document.createElement('span');photo.className='kdk-dynamic__image';
      var img=document.createElement('img');img.src=item.image;img.alt=item.title;
      img.loading='lazy';img.decoding='async';img.width=240;img.height=280;
      photo.appendChild(img);card.appendChild(photo);
      var info=document.createElement('span');info.className='kdk-dynamic__product-info';
      var prodTitle=document.createElement('span');prodTitle.className='kdk-dynamic__product-title';prodTitle.textContent=item.title;
      var price=document.createElement('span');price.className='kdk-dynamic__product-price';price.textContent=item.price;
      var explore=document.createElement('span');explore.className='kdk-dynamic__product-link';explore.textContent='İncele ↗';
      info.appendChild(prodTitle);info.appendChild(price);info.appendChild(explore);card.appendChild(info);
      grid.appendChild(card);
    });
    article.appendChild(grid);
    return article;
  }
  function groupBy(group,condition){return group.filter(condition);}
  function arrange(lists){
    var result=[],max=0;
    lists.forEach(function(a){max=Math.max(max,a.length);});
    for(var i=0;i<max;i++)lists.forEach(function(list){if(list[i])result.push({kind:'recipe',look:list[i]});});
    return result;
  }
  function setup(root){
    if(!root||root.dataset.kdkStyleReady==='true')return;
    var sections=Array.prototype.slice.call(root.querySelectorAll('[data-kdk-audience]'));
    var button=root.querySelector('[data-kdk-shuffle]');
    var status=root.querySelector('[data-kdk-style-status]');
    var library=window.KDK_CURATED_LOOKS_2026||[];
    if(sections.length!==3||!button)return;
    if(library.length<100){return setupOriginal(root);}
    root.dataset.kdkStyleReady='true';
    var originalQueues=sections.map(function(section){
      return Array.prototype.slice.call(section.querySelectorAll('[data-kdk-look]'));
    });
    var existingSignatures=new Set();
    originalQueues.forEach(function(queue){queue.forEach(function(card){
      var handles=Array.prototype.slice.call(card.querySelectorAll('a.kdk-dynamic__product')).map(function(link){return getHandle(link.getAttribute('href'));});
      if(handles.length>=2)existingSignatures.add(signature(handles));
    });});
    var accepted=library.filter(function(look){return Array.isArray(look.products)&&look.products.length>=2&&look.products.every(Boolean)&&!existingSignatures.has(signature(look.products));});
    var women=groupBy(accepted,function(x){return x.audience==='women';});
    var men=groupBy(accepted,function(x){return x.audience==='men';});
    var kids=groupBy(accepted,function(x){return x.audience==='kids';});
    var families=groupBy(accepted,function(x){return x.audience==='family';});
    var jewel=groupBy(accepted,function(x){return x.audience==='jewelry';});
    var womenGroups=['kislik','yazlik','klasik','spor'].map(function(style){return groupBy(women,function(x){return x.style===style;});});
    var womenOverflow=womenGroups.map(function(list){return list.pop();}).filter(Boolean);
    var jewelryMore=jewel.slice(0,8),jewelryOverflow=jewel.slice(8);
    var additional=[
      arrange(womenGroups),
      arrange(['yazlik','kislik','klasik','spor'].map(function(s){return groupBy(men,function(x){return x.style===s;});}).concat([jewelryMore])),
      arrange(['kislik','gunluk'].map(function(s){return groupBy(kids,function(x){return x.style===s;});}).concat([families,womenOverflow,jewelryOverflow]))
    ];
    // 36 original cards + 165 curated looks with one overlap = 200 unique combinations.
    var locations=sections.map(function(section,n){
      var shown=originalQueues[n],extra=additional[n],queue=[],oldIndex=0,newIndex=0;
      var total=shown.length+extra.length;
      for(var i=0;i<total;i++){
        if(i%5===0&&oldIndex<shown.length)queue.push({kind:'dom',card:shown[oldIndex++]});
        else if(newIndex<extra.length)queue.push(extra[newIndex++]);
        else if(oldIndex<shown.length)queue.push({kind:'dom',card:shown[oldIndex++]});
      }
      while(newIndex<extra.length)queue.push(extra[newIndex++]);
      while(oldIndex<shown.length)queue.push({kind:'dom',card:shown[oldIndex++]});
      return {section:section,queue:queue,index:0,holder:section.querySelector('.kdk-dynamic__slide-holder'),originalHeader:section.querySelector('.kdk-dynamic__audience-header h3')?.textContent||'Seçki',rendered:null};
    });
    root.dataset.kdkLookCount=String(locations.reduce(function(n,x){return n+x.queue.length;},0));
    function displayOriginal(location,entry){
      location.section.querySelector('.kdk-dynamic__audience-header h3').textContent=location.originalHeader;
      if(location.rendered){location.rendered.remove();location.rendered=null;}
      originalQueues[sections.indexOf(location.section)].forEach(function(card){
        var active=card===entry.card;card.hidden=!active;
        card.setAttribute('aria-hidden',active?'false':'true');
        if(active)card.removeAttribute('inert');else card.setAttribute('inert','');
      });
    }
    function renderCurated(location,look,products){
      originalQueues[sections.indexOf(location.section)].forEach(function(card){card.hidden=true;card.setAttribute('aria-hidden','true');card.setAttribute('inert','');});
      if(location.rendered)location.rendered.remove();
      var el=buildLook(look,products);location.holder.appendChild(el);location.rendered=el;
      location.section.querySelector('.kdk-dynamic__audience-header h3').textContent=AUDIENCES[look.audience]||'Seçki';
    }
    // Every visible card has its own seen-set. Never repeat a pairing until its pool is exhausted.
    function keyFor(entry){
      if(entry.kind==='recipe')return signature(entry.look.products);
      if(entry._key)return entry._key;
      var links=Array.prototype.slice.call(entry.card.querySelectorAll('a.kdk-dynamic__product'));
      entry._key=signature(links.map(function(link){return getHandle(link.getAttribute('href'));}));
      return entry._key;
    }
    function handlesFor(entry){
      if(entry.kind==='recipe')return entry.look.products;
      return Array.prototype.slice.call(entry.card.querySelectorAll('a.kdk-dynamic__product')).map(function(link){
        return getHandle(link.getAttribute('href'));
      }).filter(Boolean);
    }
    function styleFor(entry){
      return entry.kind==='recipe'?entry.look.style:(entry.card.getAttribute('data-kdk-look-style')||'');
    }
    function maybeRestart(location){
      var hasNew=location.queue.some(function(e){
        var key=keyFor(e);
        return key&&!location.seen.has(key)&&!location.unavailable.has(key);
      });
      if(!hasNew){
        location.seen.clear();
        if(location.currentKey)location.seen.add(location.currentKey);
      }
    }
    function prioritize(location){
      var result=[];
      var len=location.queue.length;
      for(var step=1;step<=len;step++){
        var target=(location.index+step)%len,entry=location.queue[target],key=keyFor(entry);
        if(!key||location.seen.has(key)||location.unavailable.has(key)||key===location.currentKey)continue;
        var intersection=handlesFor(entry).filter(function(h){return location.currentHandles.indexOf(h)!==-1;}).length;
        var styleCost=styleFor(entry)===location.currentStyle?1:0;
        // Vary the season and brand before reusing nearly identical product imagery.
        var score=intersection*10+styleCost*5+step/len;
        result.push({target:target,entry:entry,key:key,score:score});
      }
      result.sort(function(a,b){return a.score-b.score;});
      return result;
    }
    function commit(location,candidate){
      location.index=candidate.target;
      location.seen.add(candidate.key);
      location.currentKey=candidate.key;
      location.currentHandles=handlesFor(candidate.entry);
      location.currentStyle=styleFor(candidate.entry);
    }
    async function nextFor(location){
      if(location.queue.length<2)return false;
      maybeRestart(location);
      var candidates=prioritize(location),remoteAttempts=0;
      for(var n=0;n<candidates.length;n++){
        var candidate=candidates[n],entry=candidate.entry;
        if(entry.kind==='dom'){
          displayOriginal(location,entry);
          commit(location,candidate);
          return true;
        }
        if(remoteAttempts>=8)continue;
        remoteAttempts++;
        try{
          var products=await Promise.all(entry.look.products.map(fetchProduct));
          if(products.length!==entry.look.products.length||new Set(products.map(function(p){return p.handle;})).size!==products.length){
            location.unavailable.add(candidate.key);continue;
          }
          renderCurated(location,entry.look,products);
          commit(location,candidate);
          return true;
        }catch(error){
          // A deleted, unpublished or out-of-stock product is not shown to shoppers.
          location.unavailable.add(candidate.key);
        }
      }
      return false;
    }
    // Start on existing Liquid product cards; no fetches block first paint.
    locations.forEach(function(location){
      location.seen=new Set();
      location.unavailable=new Set();
      location.currentHandles=[];
      location.currentStyle='';
      location.currentKey='';
      var current=location.queue[0];
      if(current){
        location.index=0;
        if(current.kind==='dom')displayOriginal(location,current);
        location.currentKey=keyFor(current);
        location.currentHandles=handlesFor(current);
        location.currentStyle=styleFor(current);
        if(location.currentKey)location.seen.add(location.currentKey);
      }
    });
    var working=false;
    button.disabled=!locations.some(function(x){return x.queue.length>1;});
    button.addEventListener('click',async function(){
      if(working)return;
      working=true;button.disabled=true;button.setAttribute('aria-busy','true');
      if(status)status.textContent='Yeni kombinler hazırlanıyor';
      try{
        var outcomes=await Promise.all(locations.map(nextFor));
        if(status)status.textContent=outcomes.some(Boolean)?'Yeni kombinler gösteriliyor':'Bu ürünler şu anda görüntülenemiyor';
      }finally{working=false;button.disabled=false;button.removeAttribute('aria-busy');}
    });
  }
  // Library not loaded: preserve legacy, fully functional real Shopify combinations.
  function setupOriginal(root){
    if(root.dataset.kdkStyleReady==='true')return;
    root.dataset.kdkStyleReady='true';
    var audiences=Array.prototype.slice.call(root.querySelectorAll('[data-kdk-audience]'));
    var switcher=root.querySelector('[data-kdk-shuffle]'),status=root.querySelector('[data-kdk-style-status]');
    var lists=audiences.map(function(a){return Array.prototype.slice.call(a.querySelectorAll('[data-kdk-look]'));});
    var index=0;
    if(switcher)switcher.addEventListener('click',function(){
      index+=1;lists.forEach(function(cards,n){cards.forEach(function(card,i){card.hidden=(i!==index%cards.length);});});
      if(status)status.textContent='Yeni kombinler gösteriliyor';
    });
  }
  function boot(where){
    (where||document).querySelectorAll('[data-kdk-style-module]').forEach(setup);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(ev){boot(ev.target);});
})();
